import { FormEvent, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@windmill/react-ui';
import { FormattedMessage, useIntl } from 'react-intl';
import Button from 'src/components/_common/Button/Button';
import Select from 'src/components/_common/Select/Select';
import ClassesContext from 'src/hooks/useClasses';
import { User } from 'src/models/user';
import { studentHasAdvisor } from './SupervisorSelect';

interface ConnectAdvisorModalProps {
  isOpen: boolean;
  onClose: () => void;
  classId: number;
  studentUserId: number;
  user: User;
  onConnected: () => void;
}

interface SelectOption {
  label: string;
  value: string;
}

const ConnectAdvisorModal = ({ isOpen, onClose, classId, studentUserId, user, onConnected }: ConnectAdvisorModalProps) => {
  const { formatMessage } = useIntl();
  const { usersForClass, usersForClassLoaded, setAdvisorForStudent, isSaving } = ClassesContext.useContainer();
  const [selectedAdvisor, setSelectedAdvisor] = useState<SelectOption>();

  const connectableAdvisors = usersForClass?.advisors.filter(a => !studentHasAdvisor(user, a));

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!selectedAdvisor) return;
    setAdvisorForStudent(classId, studentUserId, +selectedAdvisor.value).then(() => {
      setSelectedAdvisor(undefined);
      onConnected();
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} style={{ margin: 'auto' }}>
      <form onSubmit={handleSubmit}>
        <ModalHeader>
          <FormattedMessage id="connect-advisor" />
        </ModalHeader>
        <ModalBody>
          <Select
            name="connect-advisor"
            label={formatMessage({ id: 'supervisor' })}
            value={selectedAdvisor}
            onChange={value => setSelectedAdvisor(value as SelectOption | undefined)}
            options={connectableAdvisors?.map(a => ({ value: a.id.toString(), label: a.displayName }))}
            isLoading={!usersForClassLoaded}
            className="w-full"
          />
        </ModalBody>
        <ModalFooter>
          <Button className="w-full sm:w-auto" layout="outline" onClick={onClose}>
            <FormattedMessage id="cancel" />
          </Button>
          <Button type="submit" className="w-full sm:w-auto" isSaving={isSaving} disabled={!selectedAdvisor}>
            <FormattedMessage id="connect-advisor-submit" />
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default ConnectAdvisorModal;
